export default __webpack_public_path__ + "31442273b01d29402d3bbd15b24fd6df.png";